<template>
    <table class="equity-group-list">
        <EquityGroupItem v-for="group in filterdEquityGroupList" :key="group.id" :equityGroup="group"
            :getBalance="getBalance" :getBalanceDetailLink="getBalanceDetailLink" :disableSelectIcon="disableSelectIcon" />
    </table>
</template>
  
<script>
import EquityGroupItem from '@/components/EquityGroupItem.vue'

export default {
    props: {
        equityGroupList: {
            type: Array,
            required: true,
        },
        getBalance: {
            type: Function,
            required: true,
        },
        getBalanceDetailLink: {
            type: Function,
            required: true,
        },
    },
    components: { EquityGroupItem },
    computed: {
        filterdEquityGroupList() {
            return this.equityGroupList.filter(x => {
                return x.equity_s && x.equity_s.length > 0
            })
        },
        disableSelectIcon() {
            for (let group of this.equityGroupList) {
                if (group.equity_s && group.equity_s.length >= 2) {
                    return false
                }
            }
            return true
        }
    }
}
</script>
  
<style lang="less" scoped>
@import '~@/styles/common';

.equity-group-list {
    width: 100%;
    border: none;
    border-collapse: collapse;
    background-color: @antBackWhite;
}
</style>
  